var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowMenuLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2928 1.07967C11.9023 0.689141 11.2691 0.689141 10.8786 1.07967L0.979079 10.9792C0.588555 11.3697 0.588555 12.0028 0.979079 12.3934L10.8786 22.2929C11.2691 22.6834 11.9023 22.6834 12.2928 22.2929C12.6833 21.9023 12.6833 21.2692 12.2928 20.8787L3.1004 11.6863L12.2928 2.49388C12.6833 2.10335 12.6833 1.47019 12.2928 1.07967Z",
    fill: "#181C2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMenuLeft);
export default __webpack_public_path__ + "static/media/arrowMenuLeft.25b499288e2776b0ddbdd0571108cb62.svg";
export { ForwardRef as ReactComponent };